module.exports = __webpack_public_path__ + "fonts/prompt-v4-thai_latin-900.b1088e2b.woff2";